<template>
  <div class="page-container">
    <md-app>
      <md-app-toolbar class="md-primary">
        <md-button class="md-icon-button" @click="toggleMenu" v-if="!menuVisible">
          <md-icon>menu</md-icon>
        </md-button>
        <span class="md-title">My Title</span>
      </md-app-toolbar>

      <md-app-drawer :md-active.sync="menuVisible" md-persistent="full">
        <md-toolbar class="md-transparent" md-elevation="0">
          <span>Navigation</span>

          <div class="md-toolbar-section-end">
            <md-button class="md-icon-button md-dense" @click="toggleMenu">
              <md-icon>keyboard_arrow_left</md-icon>
            </md-button>
          </div>
        </md-toolbar>

        <md-list>
          <md-list-item>
            <md-icon>move_to_inbox</md-icon>
            <span class="md-list-item-text">Inbox</span>
          </md-list-item>

          <md-list-item>
            <md-icon>send</md-icon>
            <span class="md-list-item-text">Sent Mail</span>
          </md-list-item>

          <md-list-item>
            <md-icon>delete</md-icon>
            <span class="md-list-item-text">Trash</span>
          </md-list-item>

          <md-list-item>
            <md-icon>error</md-icon>
            <span class="md-list-item-text">Spam</span>
          </md-list-item>
        </md-list>
      </md-app-drawer>

      <md-app-content>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Error quibusdam, non molestias et! Earum magnam, similique, quo recusandae placeat dicta asperiores modi sint ea.
      </md-app-content>
    </md-app>
  </div>
</template>

<script>
import ContactUsForm from "../../components/dialogs/ContactUsForm.vue";
import SupportForm from "../../components/dialogs/SupportForm";
import AddressSearchBar from "../../components/adrSearchBar.vue";
import { getUserUid } from "../../functions.js";
import { mapActions, mapState, mapGetters } from "vuex";
import ToggleSwitch from "@/components/interface/buttons/toggleSwitch.vue";

export default {
  props: {
    showAddressSearch: {
      type: Boolean,
      default: true
    },
    overlay: {
      type: Boolean,
      default: false
    }
  },
  components: {
    "contact-form": ContactUsForm,
    "adr-search-bar": AddressSearchBar,
    "support-form": SupportForm,
    "toggle-switch": ToggleSwitch
  },
  data() {
    return {
      sideNavPresistenceValue: "mini",
      narrowWidth: false,
      showNavigation: false,
      menuVisible: false,
      showTutorial: false,
      showContactForm: false,
      showSnackbar: false,
      snackbarMessage: "",
      showSupportForm: false
    };
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    allCaps: function(value) {
      return value.toUpperCase();
    }
  },
  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),
    userAvatar() {
      if(this.$store.getters.user.pictureUrl) return this.$store.getters.user.pictureUrl
      return require("../../assets/owl_round_back.png");
    },
    loggedIn() {
      return this.$store.getters.isUserLoggedIn;
    },
    tenantFlow() {
      return require("../../assets/tenant-flow.png");
    },
    landlordFlow() {
      return require("../../assets/landlord-flow.png");
    },
    showUnreadMsgBadge() {
      return this.$store.getters.showUnreadMsgBadge;
    },
    userIsVerified() {
      return this.$store.getters.isUserVerified;
    },
    loadingUser() {
      return this.$store.getters.loadingUser;
    },
    userViewRoleIsLandlord() {
      return this.$store.getters.userViewRole == "landlord";
    }
  },
  created() {
    window.addEventListener("resize", this.handleWindowResize);
    this.handleWindowResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize);
  },
  methods: {
    ...mapActions("internationalizationModule", ["setLocale"]),
    toggleUserViewRole(isLandlord) {
      var role;
      isLandlord ? (role = "landlord") : (role = "tenant");
      this.$store.dispatch("editUserViewRole", role);
      isLandlord?this.navigateTo("dashboard"):this.navigateTo("stays");
    },
    finishedSupportForm(isSuccess) {
      this.showSupportForm = false;
      if (isSuccess == false)
        this.notifyUser("Something is not right, contact support@moowle.com");
      if (isSuccess == true)
        this.notifyUser("Ticket submitted. We will be in touch promptly");
    },
    openDrawer() {
      this.menuVisible = true;
    },
    closeDrawer() {
      this.menuVisible = false;
    },
    closeContactUsForm(isSuccess) {
      this.showContactForm = false;
      if (isSuccess == false)
        this.notifyUser("Something is not right, contact support@moowle.com");
      if (isSuccess == true)
        this.notifyUser("Thank You. We will be in touch promptly");
    },
    notifyUser(msg) {
      this.snackbarMessage = msg;
      this.showSnackbar = true;
    },
    toggleTutorial() {
      this.showTutorial = true;
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },
    handleWindowResize() {
      if (window.innerWidth <= 700) {
        this.narrowWidth = true;
        this.sideNavPresistenceValue = "";
      } else {
        this.narrowWidth = false;
        this.sideNavPresistenceValue = "mini";
      }
    },
    searchError(error) {
      this.$notify({
        title: "Something is not right",
        message: "Search is not working"
      });
    },
    selectPlace(googPrediction) {
      var selectedPlace = googPrediction.description;
      var placeId = googPrediction.place_id;
      var filterMuni = "";
      try {
        var filterMuni = googPrediction.structured_formatting.main_text;
      } catch (err) {}
      this.$router.push({
        name: "listingsearch",
        query: { autoq: "true", muni: filterMuni }
      });
    },
    navigateHome() {
      this.navigateTo("listingsearch")
    },
    navigateTo(where, params) {
      this.$router.push({
        name: where,
        params: params
      });
    },
    logOut() {
      this.navigateHome();
      this.$store.dispatch("logout");
    }
  }
};
</script>
<style scoped>
@import "../../assets/styles/global.css";

.side-cta-nav .md-icon {
  color: #414042;
}

.router-link-active .md-icon {
  color: #F76765 !important;
}

.overlay-toolbar {
  position: absolute;
  background-color: transparent;
  width: 100%;
  box-shadow: none;
}

.moow-toolbar {
  height: 8vh;
  background-color: white;
  box-shadow: 0 0px 4px -1px rgba(0, 0, 0, 0.2), 0 0px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
}

.main-side-nav {
  position: absolute !important;
  top: 8vh;
  /* background: transparent; */
  border: none !important;
  border-radius: 0px 8px 8px 0px;
  z-index: 999;
}



.mo-navbar-dropdown a {
  text-decoration: none;
}

.header-navbar-logo {
  margin-right: 2em;
}

.header-navbar-search {
  border: 1.2px solid #e2dede;
  border-radius: 20px;
  padding-right: 5px;
  padding-left: 5px;
  margin-left: 2em;
}

.active {
  border-bottom: 2px solid #1f8efa;
  color: black !important;
}

#nav_collapse {
  line-height: 45px;
}

.dropdown-item a {
  text-decoration: none;
}

.dropdown-item {
  outline: none;
}
.view-role-container {
  text-align: center;
  opacity: 1;
  -webkit-transition: opacity 0.5s ease-in-out;
  -moz-transition: opacity 0.5s ease-in-out;
  -ms-transition: opacity 0.5s ease-in-out;
  -o-transition: opacity 0.5s ease-in-out;
  transition: opacity 0.5s ease-in-out;
}

.view-role-container.hidden {
  opacity: 0;
}

/*  from infinity to max 600 and then this kicks in*/
@media (max-width: 600px) {
  .header-navbar-search {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/MasterHeader.vue